/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import integrationApi from '../services/integration';
import { Button, Col, Container, Form, Row, Modal, Card } from 'react-bootstrap';
// import BaoLuuBadge from '../components/BaoLuuBadge';  // TẠM TẮT — xem khối "Bảo lưu hồ sơ" bên dưới
import { useForm } from 'react-hook-form';
import drivingApi from '../services/driving';
import { LICENSE_GROUP } from '../constants/license-class.constant';
import { toast } from 'react-toastify';
import { useMemo } from 'react';
import DrivingServiceInstance from '../services/driving';
import CopyableText from '../components/CopyableText';

// Helper to get query param
function getQueryParam(param) {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
}

const SH_HANG_DU_SH = [
  { value: '515', label: 'A1m' },
  { value: '516', label: 'Am' },
];

function A1APage() {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [drivingClass, setDrivingClass] = useState('');
  const [setting, setSetting] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [colDefs] = useState([
    {
      headerName: "STT",
      valueGetter: (params) => params.node ? params.node.rowIndex + 1 : '',
      width: 80,
      pinned: "left" // Cố định cột STT bên trái
    },
    {
      field: 'Chi tiết',
      headerName: 'Phiên học',
      cellRenderer: (params) => {
        const onClick = () => {
          window.open(
            `${window.location.origin}/search?name=${params.data['Mã đăng ký']}`,
            '_blank'
          );
        };
        return (
          <Button size='sm' variant='primary' onClick={onClick} className='w-100'>
            Xem
          </Button>
        );
      },
      width: 100,
    },
    { field: 'Họ và tên', headerName: 'Tên học viên',
      flex: 1,
      minWidth: 300,
      cellRenderer: (p) => <CopyableText value={p.value} />,
     },
    { field: 'Khóa', headerName: 'Khóa', flex: 1, minWidth: 80 },
    { field: 'Mã đăng ký', headerName: 'Mã học viên', minWidth: 150, flex: 1, cellRenderer: (p) => <CopyableText value={p.value} /> },
    { field: 'Ngày sinh', headerName: 'Ngày sinh', minWidth: 150, flex: 1 },
    { field: 'Số CMND/ HC', headerName: 'Số CMND/CCCD/HC', minWidth: 150, flex: 1 },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [rowData, setRowData] = useState([]);

  // State cho chức năng điều kiện DAT (GetFlyCustomerPage)
  const [datConditionLoading, setDatConditionLoading] = useState(false);
  const [showCustomerDetail, setShowCustomerDetail] = useState(false);
  const [showRetestModal, setShowRetestModal] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [datConditionRowData, setDatConditionRowData] = useState([]);
  // react-hook-form for retest modal
  const {
    register: retestRegister,
    handleSubmit: handleRetestSubmit,
    formState: { errors: retestErrors },
    reset: resetRetestForm,
  } = useForm({
    defaultValues: {
      applicant: '',
      phone: '',
      paymentDate: '',
    },
  });
  const [datConditionColDefs] = useState([
    {
      headerName: 'STT',
      valueGetter: (params) => (params.node ? params.node.rowIndex + 1 : ''),
      width: 80,
      pinned: 'left',
    },
    {
      field: 'detail',
      headerName: 'Chi tiết',
      cellRenderer: (params) => {
        return (
          <Button
            size='sm'
            variant='primary'
            onClick={() => {
              setShowCustomerDetail(true);
              setCustomerData(params.data);
            }}
            className='w-100'
          >
            Xem
          </Button>
        );
      },
      width: 100,
    },
    {
      field: 'account_name',
      headerName: 'Tên học viên',
      flex: 1,
      minWidth: 300,
      cellRenderer: (p) => <CopyableText value={p.value} />,
    },
    {
      field: 'sh_hang_du_sh',
      headerName: 'Hạng xe',
      flex: 1,
      minWidth: 80,
      valueFormatter: (params) => {
        const license = SH_HANG_DU_SH.find(
          (lic) => lic.value === params.value
        );
        return license ? license.label : params.value;
      },
    },
    {
      field: 'khoa_hoc_label',
      headerName: 'Khoá học',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'ma_hoc_vien_theo_csdl',
      headerName: 'Mã học viên',
      minWidth: 150,
      flex: 1,
      cellRenderer: (p) => <CopyableText value={p.value} />,
    },
    {
      field: 'birthday',
      headerName: 'Ngày sinh',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'can_cuoc_cong_dan',
      headerName: 'Số CMND/CCCD/HC',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'vr_a1a2_kq',
      headerName: 'Kết quả sát hạch',
      minWidth: 150,
      flex: 1,
    },
  ]);

  // inline payment card is used; no separate modal state

  // Compute whether the student registered for retest and which price options apply
  const retestRegistered = useMemo(() => {
    return (
      customerData?.mapper?.['a1_a_dang_ky_thi_lai']?.field_value === '523'
    );
  }, [customerData]);

  const THEORY_RETEST_FEE = 60000;
  const PRACTICE_RETEST_FEE = 70000;

  const priceListForRetest = useMemo(() => {
    const theory = customerData?.mapper?.['a1_a_ket_qua_ly_thuyet']?.display_value?.toLowerCase() || '';
    const practice = customerData?.mapper?.['a1_a_ket_qua_sa_hinh']?.display_value?.toLowerCase() || '';

  // cost rules: rớt hoặc vắng đều tính như thi lại
  const theoryIsRot = theory.includes('rớt');
  const practiceIsRot = practice.includes('rớt');
  const theoryIsVang = theory.includes('vắng');
  const practiceIsVang = practice.includes('vắng');

  // base per-part cost (vắng = rớt)
  const theoryCost = theoryIsRot || theoryIsVang ? THEORY_RETEST_FEE : 0;
  const practiceCost = practiceIsRot || practiceIsVang ? PRACTICE_RETEST_FEE : 0;

    const list = [];
    const addOption = (name, examFee, description) => {
      const total = (examFee || 0);
      list.push({ name, price: total, description, examFee });
    };

    if (theoryCost > 0 && practiceCost > 0) {
      const combinedPrice = theoryCost + practiceCost;
      addOption('2 nội dung', combinedPrice, 'Thi lại cả lý thuyết và thực hành');
    }
    if (theoryCost > 0) {
      addOption('Lý thuyết', theoryCost, 'Thi lại phần lý thuyết');
    }
    if (practiceCost > 0) {
      addOption('Thực hành', practiceCost, 'Thi lại phần thực hành');
    }

    // Fallback: if registered but no explicit reason found, offer combined option using default 200k
    if (retestRegistered && list.length === 0) {
      addOption('2 nội dung', THEORY_RETEST_FEE + PRACTICE_RETEST_FEE, 'Thi lại cả lý thuyết và thực hành');
    }

    return list;
  }, [customerData, retestRegistered, THEORY_RETEST_FEE, PRACTICE_RETEST_FEE]);

  // Payment info shared for inline card
  const paymentInfo = useMemo(() => ({
    bankName: 'VietinBank eFAST',
    bankAccount: '114003037985',
    bankCode: 'ICB',
    bankOwner: 'CTY TNHH MTV VI TÍNH QUANG MINH PHÁT',
  }), []);

  // eslint-disable-next-line no-unused-vars
  const currencyFormatter = useMemo(() => new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }), []);

  const [selectedRetestPrice, setSelectedRetestPrice] = useState(priceListForRetest?.[0]?.price || 0);

  useEffect(() => {
    setSelectedRetestPrice(priceListForRetest?.[0]?.price || 0);
  }, [priceListForRetest]);

  // Compute retest type code and amount from customerData
  const _theoryDisplay = customerData?.mapper?.['a1_a_ket_qua_ly_thuyet']?.display_value?.toLowerCase() || '';
  const _practiceDisplay = customerData?.mapper?.['a1_a_ket_qua_sa_hinh']?.display_value?.toLowerCase() || '';
  const _needTheory = _theoryDisplay.includes('rớt') || _theoryDisplay.includes('vắng');
  const _needPractice = _practiceDisplay.includes('rớt') || _practiceDisplay.includes('vắng');

  const retestTypeCode = useMemo(() => {
    if (_needTheory && _needPractice) return 'CA2';
    if (_needTheory) return 'LYT';
    if (_needPractice) return 'HIH';
    // fallback when registered but no explicit result
    if (retestRegistered) return 'CA2';
    return '';
  }, [_needTheory, _needPractice, retestRegistered]);

  // eslint-disable-next-line no-unused-vars
  const retestLabel = useMemo(() => {
    if (retestTypeCode === 'CA2') return 'Thi lại lý thuyết và thực hành';
    if (retestTypeCode === 'LYT') return 'Thi lại lý thuyết';
    if (retestTypeCode === 'HIH') return 'Thi lại thực hành';
    return 'Thi lại (chưa xác định nội dung)';
  }, [retestTypeCode]);

  const retestPartFees = useMemo(() => {
    const theoryDisplay = _theoryDisplay || '';
    const practiceDisplay = _practiceDisplay || '';
    const theoryIsRot = theoryDisplay.includes('rớt');
    const practiceIsRot = practiceDisplay.includes('rớt');
    const theoryIsVang = theoryDisplay.includes('vắng');
    const practiceIsVang = practiceDisplay.includes('vắng');

    let theoryFee = theoryIsRot || theoryIsVang ? THEORY_RETEST_FEE : 0;
    let practiceFee = practiceIsRot || practiceIsVang ? PRACTICE_RETEST_FEE : 0;

    // Trường hợp fallback đã đăng ký nhưng không có kết quả rõ ràng
    if (retestRegistered && theoryFee === 0 && practiceFee === 0) {
      theoryFee = THEORY_RETEST_FEE;
      practiceFee = PRACTICE_RETEST_FEE;
    }

    const items = [];
    if (theoryFee > 0) items.push({ label: 'Thi lại lý thuyết', amount: theoryFee });
    if (practiceFee > 0) items.push({ label: 'Thi lại thực hành', amount: practiceFee });
    return items;
  }, [_theoryDisplay, _practiceDisplay, retestRegistered, THEORY_RETEST_FEE, PRACTICE_RETEST_FEE]);

  const computedRetestAmount = useMemo(() => {
    // Per-part pricing: rớt hoặc vắng đều tính như thi lại (lý thuyết 60k, thực hành 70k)
    const theoryDisplay = _theoryDisplay || '';
    const practiceDisplay = _practiceDisplay || '';
    const theoryIsRot = theoryDisplay.includes('rớt') || theoryDisplay.includes('vắng');
    const practiceIsRot = practiceDisplay.includes('rớt') || practiceDisplay.includes('vắng');

    const theoryPart = theoryIsRot ? THEORY_RETEST_FEE : 0;
    const practicePart = practiceIsRot ? PRACTICE_RETEST_FEE : 0;
    const total = theoryPart + practicePart;
    if (total > 0) return total;

    // fallback when registered but no explicit result
    if (retestRegistered) return THEORY_RETEST_FEE + PRACTICE_RETEST_FEE;
    return 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_needTheory, _needPractice, retestRegistered, THEORY_RETEST_FEE, PRACTICE_RETEST_FEE]);

  useEffect(() => {
    setSelectedRetestPrice(computedRetestAmount || 0);
  }, [computedRetestAmount]);

  // Unified retest transfer note used for display, copy and QR encoding
  const retestTransferNote = useMemo(() => {
    const accountCode = customerData?.mapper?.['account_code']?.display_value || '';
    const name = customerData?.mapper?.['account_name']?.display_value || '';
    const birthday = customerData?.mapper?.['birthday']?.display_value || '';
    const note = `${name} ${birthday} ${accountCode} ${retestTypeCode}`;
    return note;
  }, [customerData, retestTypeCode]);

  // eslint-disable-next-line no-unused-vars
  const inlineQrUrl = useMemo(() => {
    const amount = selectedRetestPrice || 0;
    return `https://img.vietqr.io/image/${paymentInfo.bankCode}-${paymentInfo.bankAccount}-WHQo7yS.jpg?amount=${amount}&addInfo=${encodeURIComponent(retestTransferNote)}&accountName=${encodeURIComponent(paymentInfo.bankOwner)}`;
  }, [selectedRetestPrice, paymentInfo, retestTransferNote]);

  // eslint-disable-next-line no-unused-vars
  function CopyButton({ text, iconOnly = false, title = 'Sao chép' }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (e) {
        console.error('Copy failed', e);
      }
    };

    const CopySvg = () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
      </svg>
    );

    if (iconOnly) {
      return (
        <Button variant='light' size='sm' onClick={handleCopy} title={title}>
          {copied ? '✓' : <CopySvg />}
        </Button>
      );
    }

    return (
      <Button variant='light' size='sm' onClick={handleCopy} title={title}>
        {copied ? '✓' : <><CopySvg />&nbsp;Sao chép</>}
      </Button>
    );
  }

  // Inline description for copy (reuse unified note)
  // eslint-disable-next-line no-unused-vars
  const inlineDescription = retestTransferNote;

  // eslint-disable-next-line no-unused-vars
  const feeBreakdown = useMemo(() => {
    const theoryItem = retestPartFees.find((f) => f.label.includes('lý thuyết'));
    const practiceItem = retestPartFees.find((f) => f.label.includes('thực hành'));
    const theoryAmount = theoryItem?.amount || 0;
    const practiceAmount = practiceItem?.amount || 0;
    return [
      { label: 'Lệ phí thi lý thuyết', amount: theoryAmount },
      { label: 'Lệ phí thi thực hành', amount: practiceAmount },
    ];
  }, [retestPartFees]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showCustomerDetail) {
      // Fetch customer detail data when the modal is opened
      getCustomerDetail(customerData?.account_id);
    }

    const fetchDrivingCenterSetting = async () => {
      try {
        const setting = await DrivingServiceInstance.getDrivingCenterSetting();
        // Use the setting as needed
        console.log('Driving Center Setting:', setting);
        setSetting(setting?.data || null);
      } catch (error) {
        console.error('Error fetching driving center setting:', error);
      }
    };

    fetchDrivingCenterSetting();
  }, [showCustomerDetail]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showCustomerDetail && customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value) {
      // Fetch elearning status if registration code is available
      getElearningStatus(
        customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value,
        customerData?.mapper?.['can_cuoc_cong_dan']?.field_value,
        customerData?.mapper?.['ma_khoa_csdl']?.field_value,
      );
    }
  }, [
    showCustomerDetail,
    customerData?.mapper?.['ma_hoc_vien_theo_csdl']?.field_value,
  ]);

  const getElearningStatus = async (registrationCode, cardNumber, courseCode) => {
    setLoading(true);
    try {
      const {data} = await drivingApi.getElearningStatusByRegistrationCode(registrationCode, cardNumber, courseCode);
      setCustomerData(prev => ({
        ...prev,
        elearningStatus: data?.elearningStatus || 'created',
        elearningLastReportAt: data?.lastReportAt || null,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Hàm lấy dữ liệu điều kiện DAT (giống GetFlyCustomerPage)
  const searchCustomerData = async (q) => {
    setDatConditionLoading(true);
    try {
      const data = await integrationApi.queryCustomers(q);
      const courses = data?.columns?.find((col => col.key === 'khoa_hoc'))?.options || [];
      const courseMap = courses.reduce((acc, course) => {
        acc[course.value] = course.label;
        return acc;
      }, {});
      data?.accounts.forEach((account) => {
        account.khoa_hoc_label = courseMap[account.khoa_hoc] || account.khoa_hoc;
      });
      setDatConditionRowData(data?.accounts || []);
    } catch (error) {
      console.error(error);
    } finally {
      setDatConditionLoading(false);
    }
  };

  // Hàm lấy chi tiết học viên (giống GetFlyCustomerPage)
  const getCustomerDetail = async (customerId) => {
    setDatConditionLoading(true);
    try {
      const data = await integrationApi.getCustomerDetail(customerId);

      if (data) {
        setCustomerData(prev => ({
          ...prev,
          ...data,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDatConditionLoading(false);
    }
  };

  const registerForRetest = async (formData) => {
    setLoading(true);

    try {
      await integrationApi.registerRetestA1A(customerData?.account_id, formData);
      toast('Đăng ký thi lại thành công!', { type: 'success' });
      getCustomerDetail(customerData?.account_id);
    } catch (error) {
      console.error(error);
      toast('Đăng ký thi lại thất bại do lỗi hệ thống.', { type: 'error' });
    } finally {
      setLoading(false);
      resetRetestForm();
      setShowRetestModal(false);
      setShowCustomerDetail(true);
    }
  };

  // Hàm xử lý tra cứu điều kiện DAT
  const handleSearchDATConditions = (e) => {
    e.preventDefault();
    if (!name) {
      alert('Vui lòng nhập tên cần tra cứu');
      return;
    }

    searchCustomerData({
      account_name: name?.trim(),
      relation_id: 21,
      ...(drivingClass && { 
        custom_fields: [{
          field_id: 203,
          field_name: 'sh_hang_du_sh',
          operator: '=',
          field_value: parseInt(drivingClass, 10),
          field_htmltype: 'select',
          field_ismultiple: false,
        }]
       }),
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = 'Tra cứu DAT';
    // If drivingClass is not set but URL has 'c', set it
    if (!drivingClass) {
      const c = getQueryParam('hang');

      if (c) {
        const licenseClass = LICENSE_GROUP.find(
          (license) => license.list_value?.toLowerCase() === c?.toLowerCase()
        );
        if (licenseClass) setDrivingClass(licenseClass.list_value);
      }
    }
  }, []);

  // State để xác định đang hiển thị bảng nào
  // eslint-disable-next-line no-unused-vars
  const [activeTable, setActiveTable] = useState('result'); // 'result' | 'condition'

  return (
    <Container
      style={{
        height: '100vh',
      }}
      fluid
    >
      <Row className='align-items-center' style={{ height: '10%' }}>
        <h2 className='text-center'>TRA CỨU A1-A</h2>
      </Row>
      <Row className='align-items-center'>
        <Col xs={8} md={8}>
          <Form.Control
            className='mb-3'
            type='text'
            placeholder='Nhập tên cần tra cứu'
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </Col>

        <Col xs={4} md={2}>
          <Form.Select
            className='mb-3'
            placeholder='Hạng xe'
            value={drivingClass}
            onChange={(e) => setDrivingClass(e.target.value)}
          >
            <option value=''>Chọn hạng xe (tùy chọn)</option>
            {SH_HANG_DU_SH.map((license) => (
              <option key={license.value} value={license.value}>
                {license.label}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} md={2}>
          <Button
            onClick={(e) => {
              setActiveTable('condition');
              handleSearchDATConditions(e);
            }}
            variant='primary'
            disabled={datConditionLoading}
            className='w-100 mb-3'
          >
            Tra cứu
          </Button>
        </Col>
      </Row>
      {datConditionLoading ? (
        <p className='text-center'>Đang tìm kiếm...</p>
      ) : (
        <div className='ag-theme-quartz' style={{ height: '65%' }}>
          {datConditionRowData.length ? (
            <AgGridReact
              rowData={datConditionRowData}
              columnDefs={datConditionColDefs}
            />
          ) : (
            <p className='text-center'>Không có dữ liệu</p>
          )}
        </div>
      )}
      <Modal
        show={showCustomerDetail}
        onHide={() => {
          setShowCustomerDetail(false);
          setCustomerData(null);
        }}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Thông tin học viên</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {datConditionLoading ? (
            <p className='text-center'>Đang tải dữ liệu...</p>
          ) : (
            <div>
              <Row>
                <Col md={12}>
                  <Card className='mb-3'>
                    <Card.Header>
                      <Card.Title>Thông tin cơ bản</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <p>
                        Tên học viên:{' '}
                        {customerData?.mapper?.['account_name']
                          ?.display_value || 'N/A'}
                      </p>
                      <p>
                        Ngày sinh:{' '}
                        {customerData?.mapper?.['birthday']?.display_value ||
                          'N/A'}
                      </p>
                      <p>
                        Số CMND/CCCD/HC:{' '}
                        {customerData?.mapper?.['can_cuoc_cong_dan']
                          ?.display_value || 'N/A'}
                      </p>
                      {/* TẠM TẮT 16/09/2026 — anh Trung: tra cứu bảo lưu là
                        * nghiệp vụ QUẢN LÝ, không thuộc màn đăng ký thi lại.
                        *
                        * Màn này nằm sau TeacherGuard, vốn cho cả DAT_TEACHER
                        * vào — mà `/v2/kqsh` cố ý KHÔNG cho vai trò đó đọc.
                        * Nơi tra cứu bảo lưu là /admin/kqsh (AdminDrivingGuard).
                        *
                        * Giữ nguyên code để bật lại: bỏ comment khối này và
                        * dòng import BaoLuuBadge ở đầu file.
                        *
                      <p className='mb-0'>
                        Bảo lưu hồ sơ:{' '}
                        <BaoLuuBadge
                          cccd={
                            customerData?.mapper?.['can_cuoc_cong_dan']
                              ?.display_value
                          }
                        />
                      </p>
                        */}
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={12}>
                  <Row>
                    <Col>
                      <Card className='mb-3'>
                        <Card.Header>
                          <Card.Title>Thông tin sát hạch</Card.Title>
                        </Card.Header>
                        <Card.Body>
                          <p>
                            <strong>TIẾN ĐỘ ĐÀO TẠO:</strong>{' '}
                            {customerData?.mapper?.['relation_id']
                              ?.display_value || 'N/A'}
                          </p>
                          <p>
                            <strong>KẾT QUẢ SÁT HẠCH:</strong>{' '}
                            {customerData?.mapper?.['vr_a1a2_kq']
                              ?.display_value || 'N/A'}
                          </p>
                          <p>
                            <strong>NGÀY THI GẦN NHẤT:</strong>{' '}
                            {customerData?.mapper?.['a1_a_ngay_sh_gan_nhat']
                              ?.display_value || 'N/A'}
                          </p>
                          {customerData?.mapper?.['vr_a1a2_kq']?.field_value
                            ?.toLowerCase()
                            ?.includes('rớt sát hạch') ? (
                            customerData?.mapper?.['a1_a_dang_ky_thi_lai']
                              ?.field_value === '523' ? (
                              <>
                                <p className='text-success'>
                                  Đã đăng ký thi lại cho học viên này.
                                </p>
                                <p>
                                  Người đăng ký:{' '}
                                  {customerData?.mapper?.[
                                    'a1_a_nguoi_nop_ho_so'
                                  ]?.display_value || 'N/A'}
                                </p>
                                <p>
                                  Số điện thoại:{' '}
                                  {customerData?.mapper?.['a1_a_sdt']
                                    ?.display_value || 'N/A'}
                                </p>
                                <p>
                                  Ngày nộp tiền:{' '}
                                  {customerData?.mapper?.[
                                    'a1_a_ngay_nop_tien_thi_lai'
                                  ]?.display_value || 'N/A'}
                                </p>
                                <p className='text-danger'>
                                  Lưu ý: Từ 1/1/2026 Thí sinh dự thi sát hạch sẽ
                                  được Trung tâm Nộp hộ Phí sát hạch dự thi theo
                                  danh sách đăng ký, Trong trường hợp VẮNG THI
                                  sẽ không được hoàn lại. Khi dự thi lần tiếp
                                  theo sẽ đóng lại Phí đầy đủ các nội dung dự
                                  thi.
                                </p>
                              </>
                            ) : (
                              <Button
                                variant='primary'
                                onClick={() => {
                                  setShowCustomerDetail(false);
                                  setShowRetestModal(true);
                                }}
                                disabled={
                                  !setting?.allowRetestingA1A || loading
                                }
                              >
                                Đăng ký thi lại
                              </Button>
                            )
                          ) : null}
                          {setting?.allowRetestingA1A ? null : (
                            <p className='text-danger'>
                              Trung tâm chưa mở đợt đăng ký thi lại
                            </p>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                    {/* {retestRegistered ? (
                      <Col md={6}>
                        <Card>
                          <Card.Header>
                            <Card.Title>
                              Thông tin thanh toán thi lại
                            </Card.Title>
                          </Card.Header>
                          <Card.Body>
                            <Row>
                              <Col md={12} className='mb-2'>
                                <p>
                                  <strong>Ngân hàng:</strong>{' '}
                                  {paymentInfo.bankName}{' '}
                                  <CopyButton
                                    text={paymentInfo.bankName}
                                    iconOnly
                                    title='Sao chép ngân hàng'
                                  />
                                </p>
                                <p>
                                  <strong>Số tài khoản:</strong>{' '}
                                  {paymentInfo.bankAccount}{' '}
                                  <CopyButton
                                    text={paymentInfo.bankAccount}
                                    iconOnly
                                    title='Sao chép số tài khoản'
                                  />
                                </p>
                                <p>
                                  <strong>Chủ tài khoản:</strong>{' '}
                                  {paymentInfo.bankOwner?.toUpperCase()}
                                </p>
                              </Col>
                              <Col md={12} className='text-center'>
                                <img
                                  src={inlineQrUrl}
                                  alt='QR thanh toán'
                                  className='img-fluid'
                                  style={{ maxWidth: 220 }}
                                />
                                <div className='mt-2'>
                                  <strong>Số tiền:</strong>{' '}
                                  {currencyFormatter.format(
                                    selectedRetestPrice || 0
                                  )}{' '}
                                  <CopyButton
                                    text={String(selectedRetestPrice || 0)}
                                    iconOnly
                                    title='Sao chép số tiền'
                                  />
                                </div>
                                <div className='mt-2 small text-muted d-flex justify-content-center align-items-center'>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 8,
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: '#fff3bf',
                                        padding: '8px 12px',
                                        borderRadius: 8,
                                        fontFamily:
                                          'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
                                      }}
                                    >
                                      {`Nội dung: ${retestTransferNote}`}
                                    </div>
                                    <div>
                                      <CopyButton
                                        text={retestTransferNote}
                                        iconOnly
                                        title='Sao chép nội dung chuyển khoản'
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className='mt-3 text-start'>
                                  <p className='mb-1'>
                                    <strong>Bao gồm các lệ phí:</strong>
                                  </p>
                                  <ul className='mb-2 ps-3'>
                                    {feeBreakdown.map((fee) => (
                                      <li key={fee.label}>
                                        {fee.label}:{' '}
                                        {currencyFormatter.format(fee.amount)}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    ) : null
                    } */}
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {setting?.allowRetestingA1A && (
        <Modal
          show={showRetestModal}
          onHide={() => setShowRetestModal(false)}
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title>Đăng ký thi lại</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Bạn có chắc chắn muốn đăng ký thi lại cho học viên{' '}
              <strong>
                {customerData?.mapper?.['account_name']?.display_value || 'N/A'}
              </strong>
              ?
            </p>
            <p className='text-danger'>
              Lưu ý: Từ 1/1/2026 Thí sinh dự thi sát hạch sẽ được Trung tâm Nộp
              hộ Phí sát hạch dự thi theo danh sách đăng ký, Trong trường hợp
              VẮNG THI sẽ không được hoàn lại. Khi dự thi lần tiếp theo sẽ đóng
              lại Phí đầy đủ các nội dung dự thi.
            </p>
            <Form onSubmit={handleRetestSubmit(registerForRetest)}>
              <Form.Group className='mb-3'>
                <Form.Label>Người nộp hồ sơ</Form.Label>
                <Form.Control
                  type='text'
                  {...retestRegister('applicant', {
                    required: 'Vui lòng nhập tên người nộp hồ sơ.',
                    maxLength: {
                      value: 10,
                      message: 'Không vượt quá 10 ký tự.',
                    },
                  })}
                  isInvalid={!!retestErrors.applicant}
                />
                <Form.Control.Feedback type='invalid'>
                  {retestErrors.applicant?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Số điện thoại</Form.Label>
                <Form.Control
                  type='text'
                  {...retestRegister('phone', {
                    required: 'Vui lòng nhập số điện thoại.',
                    pattern: {
                      value: /^\d{10}$/,
                      message: 'Số điện thoại không hợp lệ.',
                    },
                  })}
                  isInvalid={!!retestErrors.phone}
                />
                <Form.Control.Feedback type='invalid'>
                  {retestErrors.phone?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className='mb-3'>
                <Form.Label>Ngày nộp tiền</Form.Label>
                <Form.Control
                  type='date'
                  {...retestRegister('paymentDate', {
                    required: 'Vui lòng chọn ngày nộp tiền.',
                  })}
                  isInvalid={!!retestErrors.paymentDate}
                />
                <Form.Control.Feedback type='invalid'>
                  {retestErrors.paymentDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                variant='primary'
                type='submit'
                className='me-2'
                disabled={loading}
              >
                Xác nhận
              </Button>
              <Button
                variant='secondary'
                onClick={() => setShowRetestModal(false)}
              >
                Hủy
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </Container>
  );
}

export default A1APage;
